import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {useFavouritesStore} from '../store/favourites';

const FavouritesCounterWrapper = styled.span<{hasFav?: boolean}>`
  background-color: ${(props) => (props.hasFav ? '#5b08a4' : '#c2cacf')};
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  color: #ffffff;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FavouritesCounter = () => {
  const {favourites} = useFavouritesStore();

  return (
    <FavouritesCounterWrapper
      hasFav={favourites?.vins && favourites?.vins?.length > 0}
    >
      {favourites?.vins ? favourites?.vins?.length : 0}
    </FavouritesCounterWrapper>
  );
};

export default FavouritesCounter;
